import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';

import NaviBarStore from '@src/business-components/navibar/store';
import Link from '@src/components/link';
import { isArray } from '@src/utils/type-utils';
import CultureSwiper from '@src/business-components/navibar/components/culture-swiper';
import cx from 'classnames';
// import LanguageSelect from '../language-select';
import aos from '../../utils/aos';
import { aLink, sliceArr } from '@src/utils/common-util';

// import $$tracker from '@src/tracker';

const styles = require('./index.less');

/**
 * NaviBar
 * @param store {NaviBarStore}
 * @returns {JSX.Element}
 * @constructor
 */
const NaviBar = ({ store }) => {
  aos.reInit();
  store.use();
  const renderGamesList = () => {
    const renderListItem = items => {
      return items.map((item, key) => {
        return (
          <Link key={key} className={styles.gameItem} href={item.game_website_link} target={'_blank'} onClick={() => {}}>
            <div className={styles.gameIcon}>
              <img src={item.game_icon} alt="" />
            </div>
            <div className={styles.textContainer}>
              <div className={styles.gameName}>{item.title}</div>
              <div className={styles.gameDesc}>{item.game_desc}</div>
            </div>
          </Link>
        );
      });
    };
    const renderListCol = (games, type) => {
      const _arr = sliceArr(games, 4);
      // console.log('_arr', _arr);
      return _arr.map((item, key) => {
        return (
          <div className={styles.gameListCol} key={key}>
            {renderListItem(item)}
            {type === '经典游戏系列' && (
              <Link className={styles.moreGamesBtn} onClick={store.redirectGames}>
                <span className={styles.moreGamesBtnContent}>全部游戏</span>
              </Link>
            )}
          </div>
        );
      });
    };

    return store.gamesMenuList.map((item, key) => {
      // console.log(store.gamesMenuList);
      return (
        <div className={styles.gameMenuItem} key={key}>
          <span className={styles.gameType}>{item.type}</span>
          <div className={styles.gameList}>
            <div className={styles.listContainer}>{renderListCol(store.gamesTypeList[item.key].games, store.gamesTypeList[item.key].type)}</div>
          </div>
        </div>
      );
    });
  };

  /**
   * 渲染精品游戏
   * @returns {unknown[]|null}
   */
  const renderRecommendGameList = () => {
    if (store.recommendGameList.length === 0) {
      return null;
    }

    return store.recommendGameList.map((item, key) => {
      return (
        <Link className={styles.recommendGameItem} key={key} href={item.websiteLink} target={'_blank'}>
          <div
            className={styles.recommendGameIcon}
            style={{
              backgroundImage: `url(${item.iconUrl})`
            }}
          />
          <div className={styles.recommendGameName}>{item.title}</div>
        </Link>
      );
    });
  };
  /**
   * 渲染链接部分
   * @param linkArr
   * @returns {*|null}
   */
  const renderLink = linkArr => {
    if (!isArray(linkArr)) {
      return null;
    }
    return linkArr.map((item, key) => {
      return (
        <div className={styles.linkItem} key={key}>
          <Link className={styles.linkItemContent} href={item.url} target={'_blank'}>
            {item.title}
          </Link>
        </div>
      );
    });
  };

  return (
    <div className={cx(styles.root, store.isActive && styles.rootAct)} {...aos.FADE_IN()} data-aos-once="true">
      {/*<div className={cx(styles.expandNaviBar, store.isExpand && styles.expandNav)} onMouseLeave={store.closeExpandMenu}>*/}
      <div className={cx(styles.expandNaviBar, store.isExpand && styles.expandNav, store.maxWidth && styles.height458)} onMouseLeave={store.closeExpandMenu}>
        <div className={cx(styles.whiteNaviBarContainer, store.maxWidth && styles.maxWidth)}>
          <div className={styles.whiteNaviBarTop}>
            <Link className={styles.blackLogo} onClick={store.redirectIndex} />
            {/*<Link className={styles.closeBtn} onClick={store.closeExpandMenu} />*/}
          </div>
          <div className={styles.whiteNaviBarBottom}>
            <div className={styles.whiteNaviBarBottomLeft}>
              <div className={styles.boutiqueGamesList}>
                <div className={styles.expandNavBarTitle}>精品游戏</div>
                <div className={styles.expandRecommendGameList}>{renderRecommendGameList()}</div>
                <div className={styles.expandRecommendGameMoreBtn}>
                  <Link className={styles.expandRecommendGameMoreBtnContent} onClick={store.redirectGames}>
                    更多游戏
                  </Link>
                  <div className={styles.arrowIcon_dark} />
                </div>
              </div>
              <div className={styles.dividerLine} />
              <div className={styles.linkContainer}>
                <div className={styles.linkCol}>
                  <div className={styles.expandNavBarTitle}>官方工具</div>
                  <div className={styles.linkList}>{renderLink(store.officialTool)}</div>
                </div>
                <div className={styles.linkCol}>
                  <div className={styles.expandNavBarTitle}>用户服务</div>
                  <div className={styles.linkList}>{renderLink(store.userService)}</div>
                </div>
                <div className={styles.linkCol}>
                  <div className={styles.expandNavBarTitle}>了解我们</div>
                  <div className={styles.linkList}>{renderLink(store.aboutUs)}</div>
                </div>
                <div className={styles.linkCol}>
                  <div className={styles.expandNavBarTitle}>加入我们</div>
                  <div className={styles.linkList}>{renderLink(store.joinUs)}</div>
                </div>
              </div>
            </div>
            <div className={styles.whiteNaviBarBottomRight}>
              <CultureSwiper store={store.cultureSwiperStore} />
            </div>
          </div>
        </div>
      </div>
      <div className={cx(styles.expandNavCover, store.isExpand && styles.showNavCover)} />
      <div className={cx(styles.mainNaviBar, store.maxWidth && styles.maxWidth)}>
        {store.isLoading && (
          <div className={styles.loadingBox}>
            <div className={styles.loadingContent} />
          </div>
        )}
        <div className={styles.mainNavBarContainer}>
          <div className={styles.leftBox}>
            <div
              className={styles.logoMenu}
              onMouseOver={store.onLogoMenuHover}
              onClick={() => {
                // $$tracker.clickSeasungames();
                aLink('https://www.seasungames.cn/#/');
              }}
            >
              <div className={styles.logoIcon} />
              <div className={styles.arrowIcon} />
            </div>
            {/*  Logo */}
            <div className={styles.jx_logo} onClick={store.goHome} />
          </div>
          {/* 导航右边预约按钮 */}
          <div className={styles.nav_btn_right}>
            {store.game_stage_config !== 'beta_download' && (
              <Link className={cx(styles.nav_btn, styles.btn_appointment, store.phone && styles.btn_appointment_done)} onClick={store.appointment} />
            )}
            <Link href="https://jxqy.seasungames.cn/index/index.html" target="_blank" className={cx(styles.nav_btn, styles.btn_web)} />
          </div>
        </div>
        <div className={styles.bg} />
      </div>
    </div>
  );
};

export default wrapStore(NaviBar, NaviBarStore);
